// extracted by mini-css-extract-plugin
export default {"label":"TaskStatus_label__EZFr+"};